module.exports = __webpack_public_path__ + "static/media/r1.44b70651.jpg";